import { CircleNotch } from '@phosphor-icons/react';

export function FullPageLoader() {
    return (
        <div
            role="status"
            aria-live="polite"
            aria-busy="true"
            className="flex min-h-screen items-center justify-center bg-background"
        >
            <CircleNotch
                weight="regular"
                className="h-6 w-6 animate-spin text-muted-foreground"
                aria-hidden
            />
            <span className="sr-only">Loading</span>
        </div>
    );
}
